/* CUSTOM — open the desktop nav on hover
   Dawn's nav is a <details> opened by clicking its <summary>, which there is no
   CSS route around: `open` is an attribute, not a state a selector can set. So
   hover drives the attribute directly and Dawn's own machinery carries on
   working — setting `.open` fires the same `toggle` event `header-menu`
   listens for, and the panel's open animation is keyed off `[open]` either way.

   Applied to every top-level dropdown in the inline menu, not just the mega
   one: a nav where one item opens on hover and its neighbours need a click
   reads as a bug rather than a choice.

   Only on desktop pointer devices — a touch device reports no hover, and there
   the original click behaviour is the correct one. */

(() => {
  const nav = document.querySelector('.header__inline-menu');
  if (!nav) return;

  const desktop = window.matchMedia('(min-width: 990px)');
  const hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* Leaving the summary and arriving at the panel means crossing the header's
     bottom padding, which belongs to neither. The delay covers that gap — the
     re-entry fires mouseenter on the wrapper again and cancels the close. */
  const CLOSE_DELAY = 200;

  nav.querySelectorAll('header-menu').forEach((menu) => {
    const details = menu.querySelector('details');
    const summary = details && details.querySelector('summary');
    if (!details || !summary) return;

    let timer;
    const enabled = () => desktop.matches && hoverable.matches;

    const open = () => {
      clearTimeout(timer);
      if (!enabled() || details.open) return;
      details.open = true;
      summary.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (!enabled() || !details.open) return;
        if (details.contains(document.activeElement)) return;
        details.open = false;
        summary.setAttribute('aria-expanded', 'false');
      }, CLOSE_DELAY);
    };

    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseleave', close);

    /* With hover doing the opening, a click on the summary would toggle it
       straight back shut. Swallowed for the mouse only — keyboard activation
       reports detail 0, so Enter and Space still open and close it. */
    summary.addEventListener('click', (event) => {
      if (enabled() && event.detail > 0) event.preventDefault();
    });
  });
})();
